<!-- <template>
    <nav class="breadcrumb">
      <ul>
        <li v-for="(route, index) in matchedRoutes" :key="index">
          <router-link :to="route.path" class="remove-a-style">{{ route.meta.breadcrumb }}</router-link>
          <span v-if="index < matchedRoutes.length - 1"> <v-icon icon="mdi-chevron-right"></v-icon> </span>
        </li>
      </ul>
    </nav>


  </template> -->
  <template>

    <div class="breadcrumb">
      <ul>
        <li v-for="(step, index) in breadcrumbSteps" :key="index">
          <router-link :to="step.to" >{{ step.name }}</router-link>
          <span v-if="index < breadcrumbSteps.length - 1" style="margin:0px;"> <v-icon style="font-size: 22px;" icon="mdi-chevron-right"></v-icon>  </span>
        </li>
      </ul>
    </div>
  </template>

  <script>
  export default {
    computed: {
      breadcrumbSteps() {
        // The module landing route is shared; give Production its own dashboard label.
        if (this.$route.name === 'module-features' && ['production', 'prd'].includes(this.$route.params.prefix)) {
          return [
            { name: 'Production', to: '/module/production' },
            { name: 'Dashboard', to: '/module/production' },
          ];
        }
        const rawSteps = [];

        // Collect all breadcrumb steps from matched routes
        for (const route of this.$route.matched) {
          if (route.meta && route.meta.breadcrumb) {
            if (Array.isArray(route.meta.breadcrumb)) {
              route.meta.breadcrumb.forEach(step => {
                rawSteps.push({
                  name: step.trim(),
                  to: `${route.path}`,
                });
              });
            } else {
              rawSteps.push({
                name: route.meta.breadcrumb.trim(),
                to: !(route.path).startsWith('/home') ? `/module${route.path}` : route.path,
              });
            }
          }
        }

        // Remove consecutive duplicates and apply concise naming
        const steps = [];
        let lastStepName = '';

        for (const step of rawSteps) {
          // Skip if this step is the same as the previous one (prevents duplicates)
          //console.log(step.name,lastStepName);
          if (step.name && step.name !== lastStepName) {
            const conciseName = this.makeConcise(step.name, step.to);
            steps.push({
              name: conciseName,
              to: step.to,
            });
            lastStepName = step.name;
          }
        }

        return steps;
      },
    },
    methods: {
      makeConcise(name, routePath = '') {
        if (!name) return '';

        // Common abbreviations for shorter, clearer breadcrumbs
        const abbreviations = {
          'Purchase Management': 'Purchase',
          'Purchase Reports': 'Purchase Reports',
          'Requisition Management': 'Requisition',
          'Inventory Management': 'Inventory',
          'Human Resource Management': 'HRM',
          'Payroll Management': 'Payroll',
          'Administration': 'Admin',
          'User Management': 'Users',
          'Role Management': 'Roles',
          'Module Management': 'Modules',
          'Customer Management': 'Customers',
          'Supplier Management': 'Suppliers',
          'Dashboard': 'Dashboard',
        };

        // Check if there's a direct abbreviation
        if (abbreviations[name]) {
          return abbreviations[name];
        }

        // Convert "List" to "Record" for routes ending with "-record" to match menu names
        let processedName = name;
        if (routePath && routePath.includes('-record')) {
          // This is a record route, convert "List" to "Record" to match menu
          if (name.includes('List')) {
            processedName = name.replace(/\bList\b/gi, 'Record');
          }
          // Also fix specific menu name mismatches
          if (name.includes('Refund Voucher List')) {
            processedName = name.replace('Refund Voucher List', 'Refund Receive Voucher Record');
          } else if (name.includes('Refund Pay Voucher List')) {
            processedName = name.replace('Refund Pay Voucher List', 'Pay Receive Voucher Record');
          } else if (name.includes('Opening Balance List')) {
            processedName = name.replace('Opening Balance List', 'Opening Balance Voucher Record');
          } else if (name.includes('Journal Vourcher List')) {
            processedName = name.replace('Journal Vourcher List', 'Journal Record');
          }
        }

        // Remove redundant words and make it shorter
        let concise = processedName
          .replace(/\bManagement\b/gi, '')
          .replace(/\bAdd\b/gi, 'Add')
          .replace(/\bView\b/gi, 'View')
          .replace(/\bRecord\b/gi, 'Record')
          .replace(/\s+/g, ' ')
          .trim();

        // Truncate very long names (more than 30 characters)
        if (concise.length > 30) {
          concise = concise.substring(0, 27) + '...';
        }

        return concise || name; // Return original if empty after processing
      },
    },
  };
  </script>


  <!-- <script>
  export default {
    computed: {
      matchedRoutes() {
        return this.$route.matched.filter(route => route.meta && route.meta.breadcrumb);
      },
    },
  };
  </script> -->
  
<style>

.breadcrumb {
  list-style: none;
  margin: 0;
  padding: 0;

  padding:3px 10px;
  border-radius: 3px;
}

.breadcrumb li {
  display: inline;
  margin-right: 5px; 
}

.breadcrumb li a {
  text-decoration: none;
  color: #333; /* Breadcrumb text color */
  font-size:12px;
}

.breadcrumb li span {
  color: #ccc; 
  margin: 0 5px; 
}

.breadcrumb li:last-child span {
  display: none; 
}
.breadcrumb li:last-child>a {
  color:gray;
  opacity: .8;
}
</style>

  